import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { envUrl } from '../app/services/environment/EnvironmentService';
import ApprovalsPage from '../app/approvals/ApprovalsPageContainer';
import ApprovalList from '../app/approvals/list/ApprovalsListContainer';

const componentMap = {
  ApprovalsPage,
  ApprovalList,
};

const ApprovalRoutes = ({ componentMapOverride }) => {
  const pages = componentMapOverride ? componentMapOverride(componentMap) : componentMap;

  return (
    <ApprovalsPage>
      <Switch>
        <Route exact path={envUrl('/approvals/declined')} render={() => <div>declined</div>} />
        <Route exact path={envUrl('/approvals/awaiting')} render={() => <pages.ApprovalList isApprovalsView />} />
        <Redirect to={envUrl('/approvals/awaiting')} />
      </Switch>
    </ApprovalsPage>
  );
};
export default ApprovalRoutes;
